module.exports = "https://web-assets-production.autolist.com/_next/static/images/tampa-fl-ac55e78f49df017706ecd920531368d3.jpg";